"use client";
import { jsx as e } from "react/jsx-runtime";
import * as r from "@radix-ui/react-toggle-group";
import { forwardRef as g } from "react";
const m = g((o, t) => /* @__PURE__ */ e(r.Root, { "data-slot": "toggle-group", ...o, ref: t }));
m.displayName = "ToggleGroupRoot";
const p = g((o, t) => /* @__PURE__ */ e(r.Item, { "data-slot": "toggle-group-item", ...o, ref: t }));
p.displayName = "ToggleGroupItem";
export {
  p as ToggleGroupItem,
  m as ToggleGroupRoot
};
